import { ChevronsRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import useScreenSize from '@/hooks/useScreenSize';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import Condition from '@/utils/condition';
import './banner-v1.css';
import './banner-v2.css';

export default function Banner() {
  const { t } = useTranslation();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { title, subtitle } = useAppSelector(ConfigSlice.selectors.banner);
  const { enableStickyMobileHead } = useAppSelector(ConfigSlice.selectors.header);
  const isLongReadShown = useAppSelector(GeneralSlice.selectors.isLongReadShown);
  const page = useAppSelector(GeneralSlice.selectors.page);
  const size = useScreenSize();
  const resolvedTitle = Condition.getFirst(title);
  const resolvedSubtitle = Condition.getFirst(subtitle);

  if (!resolvedTitle || !resolvedSubtitle) return null;

  if (cssVersion === 2 && (page === 'landing-page' || page === 'landing-page-no-sidebar')) return null;

  return (
    <div
      data-css-version={cssVersion}
      data-sticky-header={!!(enableStickyMobileHead && isLongReadShown)}
      className='banner'
    >
      <div className='banner__title'>
        <div dangerouslySetInnerHTML={{ __html: t(resolvedTitle[size]) }} />
      </div>
      <div className='banner__label' id='banner-label'>
        <div className='banner__label-content'>
          <ChevronsRight className='banner__chevron' />
          <span dangerouslySetInnerHTML={{ __html: t(resolvedSubtitle) }} />
        </div>
      </div>
      {cssVersion === 1 && (
        <svg className='banner__triangle' viewBox='0 0 25 13'>
          <path d='M13 13L0 0H25L13 13Z' />
        </svg>
      )}
    </div>
  );
}
